import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div`
	position: absolute;
	top: 160px;
	right: 80px;
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledContainer = styled.div`
	position: relative;
	background: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 30px 20px 20px;

	& > img {
		display: block;
		margin: 0 auto;
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledItemsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 60px;
	height: 420px;
	overflow-y: scroll;
	overflow-x: hidden;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledTopGradient = styled.div`
	position: absolute;
	top: 180px;
	left: 0;
	width: 100%;
	height: 60px;
	background: linear-gradient(180deg, rgba(19, 21, 22, 0) 0%, #111314 100%);
	transform: matrix(1, 0, 0, -1, 0, 0);
	transition: opacity 0.3s ease;
	pointer-events: none;
	z-index: 3;
`;

const StyledBottomGradient = styled.div`
	position: absolute;
	bottom: 79px;
	left: 0;
	width: 100%;
	height: 60px;
	background: linear-gradient(180deg, rgba(19, 21, 22, 0) 0%, #111314 100%);
	transition: opacity 0.3s ease;
	pointer-events: none;
	z-index: 3;
`;

const StyledButtonContainer = styled.div`
	position: relative;
`;

const StyledHint = styled.div`
	position: absolute;
	top: 3px;
	left: -278px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 258px;
	height: 49px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #ffffff;
	pointer-events: none;
	transition: opacity 0.3s ease;

	${Text} {
		font-size: 16px;
		color: #000000;
	}
`;

export {
	StyledBottomGradient,
	StyledButtonContainer,
	StyledContainer,
	StyledHint,
	StyledItemsList,
	StyledTopGradient,
	StyledWrapper,
};
